import React, { memo, useContext, useState } from 'react';
import { Button, Icon, Popover, Tooltip } from 'antd';
import RecordsPanelContainer from '../../containers/records-panel.container';
import { SipPhoneContext } from '../SipPhoneProvider';
import { PhoneIcon, RecordIcon } from '../../resource/icons';
import BindCallToRequest from '../BindCallToRequest/BindCallToRequest';
import useSipStates from '../../hooks/useSipStates';
import styles from './PhoneRecords.module.scss';

const PhoneRecordsButton = ({
  tooltipTitle,
  getPopupContainer,
  newDesign,
  onClick,
  ...props
}) => {
  const handleClick =
    typeof onClick === 'function'
      ? (e) => {
          e.stopPropagation();
          onClick(e);
        }
      : undefined;

  return (
    <Tooltip title={tooltipTitle} getPopupContainer={getPopupContainer}>
      {!newDesign && (
        <Button
          {...props}
          ghost
          shape="circle"
          className={styles.button}
          onClick={handleClick}
        >
          <RecordIcon
            className={styles.oldIcon}
            style={{ height: '20px', marginTop: '0px' }}
          />
        </Button>
      )}
      {newDesign && (
        <PhoneIcon
          {...props}
          className={styles.newIcon}
          onClick={handleClick}
        />
      )}
    </Tooltip>
  );
};

const PhoneRecords = ({
  requestId,
  hasRecord,
  newDesign,
  className,
  getPopupContainer = () => document.body,
  onBindCallSuccess,
}) => {
  const { call } = useContext(SipPhoneContext);

  const { isConnected } = useSipStates();

  const [popoverVisible, setPopoverVisible] = useState(false);

  const commonBtnProps = {
    getPopupContainer,
    newDesign,
  };

  const canBindCall = isConnected && call.info?.id;

  if (canBindCall && !hasRecord) {
    return (
      <BindCallToRequest
        requestId={requestId}
        onSuccess={onBindCallSuccess}
        render={({ onClick }) => (
          <PhoneRecordsButton
            {...commonBtnProps}
            tooltipTitle="Прикрепить звонок"
            onClick={onClick}
          />
        )}
      />
    );
  }

  return (
    <Popover
      visible={popoverVisible}
      className={className}
      content={<RecordsPanelContainer request={requestId} />}
      title={
        <div className={styles.header}>
          <div className={styles.title}>
            <Icon type="phone" /> <span>Звонки</span>
          </div>
          <Button
            shape="circle"
            icon="close"
            style={{ border: 'none' }}
            onClick={() => setPopoverVisible(false)}
          />
        </div>
      }
      trigger="click"
      placement="right"
      style={
        newDesign ? { width: 24, height: 24, lineHeight: '1em' } : undefined
      }
      getPopupContainer={getPopupContainer}
    >
      <PhoneRecordsButton
        {...commonBtnProps}
        tooltipTitle="Звонки"
        onClick={() => setPopoverVisible(true)}
      />
    </Popover>
  );
};

export default memo(PhoneRecords);
